import { Component, OnInit } from "@angular/core";
import { OrderWizardService } from "../../../_service/order-wizard.service";
import { CommonModule, DatePipe } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { PrintService } from "src/app/features/service/print.service";
import { RouterModule } from "@angular/router";

@Component({
    selector: 'order-wizard-payment-success',
    templateUrl: './payment-success.component.html',
    imports: [CommonModule, DatePipe, TranslateModule, RouterModule]
})
export class OrderPaymentSuccessComponent implements OnInit {

    constructor(
        public _orderWizardService: OrderWizardService,
        private _printService: PrintService
    ) {

     }

    ngOnInit(): void {
 
    }

    print() {
        var commandNumber = this._orderWizardService.orderWizard$()?.step01?.code;
        // if(!commandNumber){
        //     commandNumber = "CMD-260505-6E48-KH2LQYB";
        // }
        const url = "api/order/download-invoice/"+commandNumber; 
        // console.log("download invoice for ", commandNumber, url);
        window.open(url, '_blank');
    }

}